import { DEFAULTS } from "./defaults.js";
import { GALLERY_TYPE } from "./types.js";
import { nodeViewRenderers } from "./viewer/node-view-renderers.js";
const pluginGallery = (config) => {
  return {
    config: { ...DEFAULTS.containerData, ...config },
    type: GALLERY_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginGallery
};
//# sourceMappingURL=viewer.js.map
